"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootStyle = void 0;

var _emotion = require("emotion");

var rootStyle =
/*#__PURE__*/
(0, _emotion.css)("position:relative;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.36;letter-spacing:normal;padding:10px 20px;&:last-child{padding-bottom:20px;}");
exports.rootStyle = rootStyle;